import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { prodApi, fmtKg, fmtPct, fmtEur, fmtDate } from "./prodApi";
import { useProd } from "./ProdApp";
import { PButton, PTitle, PCard, PEmpty, Spinner, PBadge, PSelect } from "./ProdUi";

export default function ProdRuns() {
  const navigate = useNavigate();
  const { recipes } = useProd();
  const [list, setList] = useState(null);
  const [recipeId, setRecipeId] = useState("");

  useEffect(() => {
    setList(null);
    prodApi.get("/production/runs", { params: recipeId ? { recipe_id: recipeId } : {} }).then((r) => setList(r.data)).catch(() => setList([]));
  }, [recipeId]);

  return (
    <div data-testid="prod-runs-page">
      <PTitle kicker="Storico" title="Lavorazioni reali" right={<PButton variant="success" onClick={() => navigate("/produzione/resa-rapida")} data-testid="prod-runs-new">Nuova resa reale</PButton>}>
        Ogni lavorazione conserva la ricetta usata e confronta resa teorica e resa reale.
      </PTitle>
      <PSelect value={recipeId} onChange={(e) => setRecipeId(e.target.value)} className="max-w-md mb-4" data-testid="prod-runs-filter-recipe">
        <option value="">Tutte le ricette</option>
        {recipes.map((r) => <option key={r.id} value={r.id}>{r.input_node_name} → {r.name}</option>)}
      </PSelect>
      {list === null && <Spinner text="Caricamento..." />}
      {list?.length === 0 && <PEmpty title="Nessuna lavorazione registrata" text="Avvia una nuova 'Resa reale rapida' dal menu per registrare i pesi ottenuti in reparto." testId="prod-runs-empty" />}
      <div className="space-y-2">
        {list?.map((r) => {
          const m = r.result?.mass || {}; const c = r.result?.comparison || {}; const res = r.result?.result || {};
          return (
            <Link to={`/produzione/lavorazioni/${r.id}`} key={r.id} className="block" data-testid={`prod-run-row-${r.number}`}>
              <PCard className="flex flex-col md:flex-row md:items-center gap-3 hover:border-blue-500/60 transition-colors">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="font-['Chivo'] font-black text-white">{r.recipe_name}</span>
                    <PBadge>{r.number}</PBadge>
                    {r.status === "open" && <PBadge tone="amber">aperta</PBadge>}
                  </div>
                  <p className="text-xs text-slate-400 mt-0.5">{fmtDate(r.date)} · {r.input_node_name} · {r.operator}{r.supplier_name ? ` · ${r.supplier_name}` : ""}{r.origin ? ` · ${r.origin}` : ""}</p>
                </div>
                <div className="grid grid-cols-4 gap-3 text-right tabular-nums">
                  <div><p className="text-[10px] uppercase text-slate-500 font-bold">Input</p><p className="font-bold text-white">{fmtKg(m.input_kg, 1)} kg</p></div>
                  <div><p className="text-[10px] uppercase text-slate-500 font-bold">Resa reale</p><p className={`font-bold ${c.diff_sellable_kg >= 0 ? "text-emerald-400" : "text-amber-400"}`}>{fmtPct(m.sellable_yield_pct)}</p><p className="text-[10px] text-slate-500">teorica {fmtPct(c.yield_theoretical_pct)}</p></div>
                  <div><p className="text-[10px] uppercase text-slate-500 font-bold">Non ric.</p><p className={`font-bold ${m.reconciled ? "text-slate-300" : "text-amber-400"}`}>{fmtKg(m.unreconciled_kg, 2)}</p></div>
                  <div><p className="text-[10px] uppercase text-slate-500 font-bold">Margine</p><p className={`font-bold ${res.margin < 0 ? "text-red-400" : "text-emerald-400"}`}>{r.input?.price_per_kg ? fmtEur(res.margin) : "—"}</p></div>
                </div>
              </PCard>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
